import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "Enable a guest user to return information for a specified cart.";
export const method = "GET";
export const operationId = "quoteGuestCartRepositoryV1GetGet";
export const path = "/V1/guest-carts/{cartId}";
export interface PathParams {
    cartId: string;
}
export type Response = Response200 | Response400 | ResponseDefault;
export type Response200 = Definitions.QuoteDataCartInterface;
export type RespKeys = (keyof Definitions.QuoteDataCartInterface)[];
export type Response400 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "getJSON">;
export function execute<T extends RespKeys | undefined>(pathParams: PathParams, effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.QuoteDataCartInterface, T[number]>> : Observable<Response200> {
    return effects.getJSON(effects.apiUrl(operationId)(path, pathParams, fields), effects.restHeaders({})) as any;
}
